import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

interface PieChartCompProps {
  data: {
    id: string | number;
    total: number;
  }[];
}

const PieChartComp: React.FC<PieChartCompProps> = ({ data }) => {
  const COLORS = [
    '#ADD8E6',
    '#FFB6C1',
    '#FFFACD',
    '#F5FFFA',
    '#D3D3D3',
    '#FAFAD2',
    '#E6E6FA',
    '#FFDAB9',
    '#F0FFF0',
  ];

  return (
    <div style={{ width: '100%', height: '300px' }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="total"
            nameKey="id"
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#8884d8"
            label
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartComp;
